/* oskarzz — subscription cards + quantity pills */

(function () {

  /* ── Helpers ─────────────────────────────────────────────────── */

  function formatMoney(cents, fmt) {
    if (!fmt) fmt = window.Shopify?.money_format || '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  }

  function perDay(priceCents, fmt) {
    return formatMoney(Math.round(priceCents / 30), fmt) + '/day';
  }

  /* ── Read product data ───────────────────────────────────────── */

  const dataEl = document.getElementById('oskarzz-product-data');
  if (!dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const { price, sub_price, discount_pct, money_format, selling_plan_id, selling_plan_name } = data;
  const hasPlan = selling_plan_id !== null;

  let activePlanValue = hasPlan ? String(selling_plan_id) : '';

  /* ── Try to click the correct option inside the native widget ── */
  function activateNativeOption(widget, isSub) {
    if (!widget) return;
    const radios = Array.from(widget.querySelectorAll('input[type="radio"]'));
    for (const r of radios) {
      const hasValue = r.value && r.value !== '' && r.value !== '0';
      if ((isSub && hasValue) || (!isSub && !hasValue)) {
        r.click();
        r.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
    const planEls = Array.from(widget.querySelectorAll(
      '[data-selling-plan-id], [data-plan-id], [data-selling-plan], [data-value]'
    ));
    for (const el of planEls) {
      const val = el.dataset.sellingPlanId || el.dataset.planId
               || el.dataset.sellingPlan   || el.dataset.value || '';
      const hasValue = val !== '' && val !== '0' && val !== 'null';
      if ((isSub && hasValue) || (!isSub && !hasValue)) { el.click(); return; }
    }
    const btns = Array.from(widget.querySelectorAll('button'));
    if (isSub  && btns[0]) btns[0].click();
    if (!isSub && btns[1]) btns[1].click();
  }

  /* ── Get or create selling_plan input on the product form ────── */
  function getSellingPlanInput() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    let input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = 'selling_plan';
      input.value = activePlanValue;
      form.appendChild(input);
    }
    return input;
  }

  /* ── Lock selling_plan before form submission ─────────────────── */
  function attachSubmitLock(sellingPlanInput) {
    const form = sellingPlanInput?.closest('form') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.opSubmitLock) return;
    form.dataset.opSubmitLock = '1';
    form.addEventListener('submit', () => {
      if (sellingPlanInput) sellingPlanInput.value = activePlanValue;
    }, { capture: true });
  }

  /* ── Build UI — scoped to product-form-component only ─────────── *
   * Searching within product-form-component[data-product-id] means *
   * we never accidentally match cart drawer or quick-add selectors. */
  function buildUI() {
    const form = document.querySelector('product-form-component[data-product-id]');
    if (!form) return false;

    const section = form.closest('.shopify-section') || form;

    /* Already built — nothing to do */
    if (section.querySelector('.op-wrapper')) return true;
    const widget  = section.querySelector(
      '.shopify-app-block, [data-shopify-app-block-id], .rc_widget, [class*="SubscriptionWidget"], [class*="subscription-widget"]'
    );
    const nativeQty = form.querySelector('.quantity-selector-wrapper');

    if (!widget && !nativeQty) return false;

    if (hasPlan) activateNativeOption(widget, true);

    const sellingPlanInput = getSellingPlanInput();
    if (sellingPlanInput) {
      sellingPlanInput.value = activePlanValue;
      sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    attachSubmitLock(sellingPlanInput);

    const qtyInput = nativeQty?.querySelector('input[name="quantity"]');

    const subPriceHTML = hasPlan ? `
      <div class="op-price-block">
        <div class="op-price-main">
          <span class="op-price-sale">${formatMoney(sub_price, money_format)}</span>
          ${sub_price < price ? `<span class="op-price-orig">${formatMoney(price, money_format)}</span>` : ''}
        </div>
        <span class="op-price-day">${perDay(sub_price, money_format)}</span>
      </div>` : '';

    const otPriceHTML = `
      <div class="op-price-block">
        <div class="op-price-main">
          <span class="op-price-sale">${formatMoney(price, money_format)}</span>
        </div>
        <span class="op-price-day">${perDay(price, money_format)}</span>
      </div>`;

    const wrapper = document.createElement('div');
    wrapper.className = 'op-wrapper';
    wrapper.innerHTML = `
      <div class="op-qty-wrap">
        <span class="op-qty-label">Quantity</span>
        <div class="op-qty-pills" role="group" aria-label="Quantity">
          <button type="button" class="op-qty-pill op-qty-pill--active" data-val="1">1</button>
          <button type="button" class="op-qty-pill" data-val="2">2</button>
          <button type="button" class="op-qty-pill" data-val="3">3</button>
        </div>
      </div>
      <div class="op-sub-ui">
        ${hasPlan ? `
        <div class="op-card op-card--sub op-card--active" data-type="subscribe">
          <div class="op-badge">MOST POPULAR${discount_pct ? ` — SAVE ${discount_pct}%` : ''}</div>
          <div class="op-card__row">
            <div class="op-card__left">
              <span class="op-radio op-radio--active"></span>
              <div class="op-card__labels">
                <span class="op-card__title">Subscribe &amp; Save</span>
                <span class="op-card__sub">${selling_plan_name || 'Recurring'}</span>
              </div>
            </div>
            ${subPriceHTML}
          </div>
          <ul class="op-benefits">
            <li><span class="op-check">✓</span>Free shipping on first order</li>
            <li><span class="op-check">✓</span>Cancel or pause any time</li>
            <li><span class="op-check">✓</span>EU certified ingredients</li>
          </ul>
        </div>` : ''}
        <div class="op-card op-card--once ${hasPlan ? '' : 'op-card--active'}" data-type="onetime">
          <div class="op-card__row">
            <div class="op-card__left">
              <span class="op-radio ${hasPlan ? '' : 'op-radio--active'}"></span>
              <div class="op-card__labels">
                <span class="op-card__title">One-time purchase</span>
                <span class="op-card__sub">Single delivery</span>
              </div>
            </div>
            ${otPriceHTML}
          </div>
          <ul class="op-downsides">
            <li><span class="op-cross">✕</span>No discount</li>
            <li><span class="op-cross">✕</span>No free shipping</li>
          </ul>
        </div>
      </div>`;

    wrapper.querySelectorAll('.op-qty-pill').forEach(btn => {
      btn.addEventListener('click', () => {
        wrapper.querySelectorAll('.op-qty-pill').forEach(b => b.classList.remove('op-qty-pill--active'));
        btn.classList.add('op-qty-pill--active');
        if (qtyInput) {
          qtyInput.value = btn.dataset.val;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
        }
      });
    });

    wrapper.querySelectorAll('.op-card').forEach(card => {
      card.addEventListener('click', () => {
        const isSub = card.dataset.type === 'subscribe';
        activePlanValue = isSub && hasPlan ? String(selling_plan_id) : '';
        activateNativeOption(widget, isSub);
        if (sellingPlanInput) {
          sellingPlanInput.value = activePlanValue;
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        wrapper.querySelectorAll('.op-card').forEach(c => {
          c.classList.remove('op-card--active');
          c.querySelector('.op-radio')?.classList.remove('op-radio--active');
        });
        card.classList.add('op-card--active');
        card.querySelector('.op-radio')?.classList.add('op-radio--active');
      });
    });

    const anchor = widget || nativeQty;
    anchor.parentNode.insertBefore(wrapper, anchor);

    const hide = 'position:absolute;visibility:hidden;pointer-events:none;height:0;overflow:hidden;';
    if (widget)    widget.style.cssText    = hide;
    if (nativeQty) nativeQty.style.cssText = hide;

    return true;
  }

  /* ── Intercept cart/add fetch ────────────────────────────────── */
  let fetchIntercepted = false;
  function interceptCartAdd() {
    if (fetchIntercepted) return;
    fetchIntercepted = true;
    const _fetch = window.fetch;
    window.fetch = function (url, opts) {
      const urlStr = url instanceof Request ? url.url : String(url);
      if (urlStr.includes('/cart/add') && opts && opts.body instanceof FormData) {
        if (activePlanValue) {
          opts.body.set('selling_plan', activePlanValue);
        } else {
          opts.body.delete('selling_plan');
        }
      }
      return _fetch.apply(this, arguments);
    };
  }

  /* ── Init ────────────────────────────────────────────────────── *
   * Observer is scoped to the product section only — it will never *
   * fire on cart drawer or quick-add DOM changes.                  *
   * It stays alive so it catches morphs that happen after the      *
   * initial build (e.g. variant-picker re-rendering the section).  */
  function setup() {
    interceptCartAdd();
    buildUI();

    const section = document.querySelector('product-form-component[data-product-id]')
      ?.closest('.shopify-section');

    if (section) {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!section.querySelector('.op-wrapper')) buildUI();
        }, 150);
      }).observe(section, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', buildUI);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

})();
